package com.macrofocus.eflux.network.lightning

import org.locationtech.jts.geom.Geometry
import org.molap.dataframe.ListDataFrameBuilder

data class LightningCluster(val risk_time: String,
                            val cluster_id: String,
                            val order: Int,
                            val type: String,
                            val geometry: Geometry?,
                            val area: Double?,
                            val strike_count: Int
    ) {
    companion object {
        val dataFrameBuilder: ListDataFrameBuilder<LightningCluster, String>.() -> Unit = {
            "risk_time" to { risk_time }
            "cluster_id" to { cluster_id }
            "order" to { order }
            "type" to { type }
            "geometry" to { geometry }
            "area" to { area }
            "strike_count" to { strike_count }
        }
    }
}